import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import ResourceSummaryCard from 'Components/ComponentLibrary/Components/Uncategorized/ResourceSummaryCard';
import useAsyncInterval from 'Hooks/useAsyncInterval';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { ACH_RELATIONSHIP_STATUSES } from 'Consts/managedAccountFunding';

export default function ApexFundingAccountResourceSummaryCard({
  resource, onClick, onActionClick,
}) {
  const { refreshPageContentCollection } = usePageContentContext();

  const [isRetryingNoCache, setIsRetryingNoCache] = useState(false);

  async function handleNoCacheResolution() {
    await refreshPageContentCollection();
    setIsRetryingNoCache(false);
  }

  async function resolveApexFundingAccountStatus(intervalControls) {
    if (resource.relationship(fr.relationships.noCache.name)) {
      const [achRelationship] = await resource.relationship(fr.relationships.noCache.name).link('related').get();
      const status = achRelationship.attr('status');
      if (status !== ACH_RELATIONSHIP_STATUSES.PENDING || status !== ACH_RELATIONSHIP_STATUSES.PENDING_ID_VERIFICATION_RESULTS) {
        intervalControls.stop();
        await handleNoCacheResolution();
      }
    } else {
      await handleNoCacheResolution();
    }
  }

  const noCacheInterval = useAsyncInterval(resolveApexFundingAccountStatus, {
    delay: 2,
    maxRetries: 10,
    maxRetriesCallback: handleNoCacheResolution,
  });

  useEffect(() => {
    if (resource.relationship(fr.relationships.noCache.name)) {
      noCacheInterval.current.start();
      setIsRetryingNoCache(true);
    }

    return () => {
      noCacheInterval.current.stop();
    };
  }, []);

  return (
    <ResourceSummaryCard
      test={'ach-relationship-card'}
      resource={resource}
      onClick={onClick}
      onActionClick={onActionClick}
      loading={isRetryingNoCache}
    />
  );
}
ApexFundingAccountResourceSummaryCard.defaultProps = {
  onClick: undefined,
  onActionClick: undefined,
};
ApexFundingAccountResourceSummaryCard.propTypes = {
  resource: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  onActionClick: PropTypes.func,
};
